export default ( money, divider=100, currency ) =>{
    if( isNaN( Number(money) ) )
        return money;

    return "$ "+(money/divider).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + (currency? ` ${currency}`:'');
}
